export enum ChangeRequestSource {
  ANALYSIS_CHECKLIST = 'analysisChecklist',
  ACTIONS_EXECUTION = 'actionsExecution',
  ACTIONS_IMPLEMENT_ALL = 'actionsImplementAll',
  ACTIONS_IMPLEMENT_ONE = 'actionsImplementOne',
  EDIT_ANALYSIS_CHECKLIST = 'editAnalysisChecklist',
  EDIT_ACTIONS_EXECUTION = 'editActionsExecution',
  EDIT_SUMMARY = 'editSummary',
}

export enum ChangeRequestDirection {
  NEXT = 'next',
  PREVIOUS = 'previous',
}

export enum ChangeRequestExportFormat {
  PDF = 'pdf',
  DOCX = 'docx',
  XLSX = 'xlsx',
  JSON = 'json',
}

export enum ChangeRequestJSONExportDepth {
  SUMMARY = 'summary',
  CHECKLIST = 'checklist',
  EXECUTION = 'execution',
}

export enum ChangeRequestListingScope {
  MY = 'my',
  ALL = 'all',
}

export enum ChangeRequestPermission {
  VIEW = 'view',
  EDIT = 'edit',
  DELETE = 'delete',
}
